module.exports = __webpack_public_path__ + "static/media/4thinks.d40008ae.png";